/**
 * @module vidaa/userManager
 * @private
 */

import { services } from "../../../constants";

const VOUCHER_QUANTITY = 1;
const APP_TYPE = "tv_app";
const ELIGIBILITY_CAMPAIGN = "samsung_tv";
const APP_ID = "3201511006673";

/**
 * Creates request body object to be sent in voucher eligibility request.
 */
async function createVoucherEligibilityRequestBody() {
  return {
    voucher_order: {
      quantity: VOUCHER_QUANTITY,
      app_type: APP_TYPE,
      eligibility_campaign: ELIGIBILITY_CAMPAIGN,
      eligibility_attributes: {
        duid: (await this.systemManager.device.getId()) || "",
        model_id: (await this.systemManager.device.getModelCode()) || "",
        app_id: APP_ID,
        mac_address: await this.systemManager.network.getMac(),
        real_model: await this.systemManager.device.getRealModel()
      }
    }
  };
}

async function createPromotionShownRequestBody() {
  return {
    deviceId: (await this.systemManager.device.getId()) || "861003009000001000000732f4f5eec08c6e58ca2ba36e623a07484d"
  };
}

/**
 * Creates request body object to be sent in eVoucher eligibility request.
 */
async function createEvoucherEligibilityRequestBody(baseVoucherCode, addonVoucherCode) {
  return {
    deviceId: (await this.systemManager.device.getId()) || "861003009000001000000732f4f5eec08c6e58ca2ba36e623a07484d",
    modelId: (await this.systemManager.device.getRealModel()) || "50A683FEVS",
    baseVoucherCode,
    addonVoucherCode
  };
}

/**
 * Checks user's device voucher validation.
 */
export async function checkEvoucherValidation(platform = "hisense-vidaa") {
  try {
    const device_id =
      (await this.systemManager.device.getId()) || "861003009000001000000732f4f5eec08c6e58ca2ba36e623a07484d";
    const response = await this.http.get(
      `${this.backendHosts.settings}${services.eVoucherValidation}?deviceId=${device_id}&platform=${platform}`
    );
    return response.data;
  } catch (error) {
    error.customCode = "EvoucherValidationFailed";
    error.customMessage = "Couldn't retrieve voucher validtion information";
    throw error;
  }
}

export async function checkEvoucherEligiblity(country, platform = "hisense-vidaa") {
  const data = await checkEvoucherValidation.call(this);
  if (data.status === "INVALID" || data.promotionShown === true) {
    return false;
  } else {
    const model_id = (await this.systemManager.device.getRealModel()) || "50A683FEVS";
    const response = await this.http.get(
      `${this.backendHosts.settings}${services.eVoucherEligibility}?model=${model_id}&country=${country}&platform=${platform}`
    );
    if (response.data.status === "INVALID") {
      return false;
    } else {
      return response.data;
    }
  }
}

/**
 * Checks user's device voucher eligibility.
 */
export async function eVoucherProvision(baseVoucherCode, addonVoucherCode) {
  try {
    const timeout = this.networkRequestTimeouts.eVoucherProvision;
    const response = await this.http.post(
      `${this.backendHosts.settings}${services.eVoucherProvision}`,
      await createEvoucherEligibilityRequestBody.call(this, baseVoucherCode, addonVoucherCode),
      {
        ...(timeout !== undefined && { timeout }),
        ...(await this.getHeaders.call(this))
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(`Couldn't provision the voucher -> ${error}`);
  }
}

export async function promotionShown() {
  try {
    const response = await this.http.post(
      `${this.backendHosts.settings}${services.eVoucherPromotionShown}`,
      await createPromotionShownRequestBody.call(this)
    );
    return response.data;
  } catch (error) {
    throw new Error(`Couldn't update Promotion Shown Information -> ${error}`);
  }
}

/**
 * Checks user's device voucher eligibility.
 */
export async function checkVoucherEligiblity() {
  try {
    const response = await this.http.post(
      `${this.backendHosts.settings}${services.voucherEligibility}`,
      await createVoucherEligibilityRequestBody.call(this)
    );
    return response.data;
  } catch (error) {
    throw new Error(`Couldn't retrieve voucher eligibility information -> ${error}`);
  }
}
